module.exports = __webpack_public_path__ + "img/triumph_logo_white.f9982861.png";